(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  // Category tabs plus an in-page filter over the already-rendered questions. The filter is
  // deliberately client-side: unlike collection filtering (which must go through Shopify's
  // Search & Discovery faceting), this only narrows text that is already on the page, so
  // there is no server-side equivalent to defer to.
  class NexFaq {
    constructor(root) {
      this.root = root;
      this.tabs = Array.from(root.querySelectorAll('[data-faq-tab]'));
      this.panels = Array.from(root.querySelectorAll('[data-faq-panel]'));
      this.searchInput = root.querySelector('[data-faq-search]');

      this.railList = root.querySelector('[role="tablist"]');
      this.dots = root.querySelector('[data-faq-dots]');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectCategory(tab.dataset.faqTab));
      });

      if (this.searchInput) {
        this.searchInput.addEventListener('input', () => this.filter());
      }

      this.initDots();
    }

    // The dots exist only while the topic chips actually overflow their container. On desktop
    // the rail is a vertical list with nothing to scroll, so this naturally reports no
    // overflow and the dots stay hidden without needing a breakpoint check in JS.
    initDots() {
      if (!this.railList || !this.dots) return;

      this.syncDots = this.syncDots.bind(this);
      this.buildDots = this.buildDots.bind(this);

      this.buildDots();

      // rAF-throttled: a touch scroll fires this continuously, and each call reads layout.
      let ticking = false;
      this.railList.addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            this.syncDots();
            ticking = false;
          });
        },
        { passive: true }
      );

      // ResizeObserver rather than a window resize listener: it also catches the rail
      // changing width without the window doing so (orientation change, editor re-render,
      // or the scrollbar appearing), which a resize event can miss.
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.buildDots);
        this.resizeObserver.observe(this.railList);
      } else {
        window.addEventListener('resize', this.buildDots);
      }
    }

    // How far the strip can actually travel. Every dot position and the active-dot maths are
    // derived from this rather than from scrollWidth, because scrollLeft can never exceed it.
    maxScroll() {
      return this.railList.scrollWidth - this.railList.clientWidth;
    }

    pageCount() {
      const clientWidth = this.railList.clientWidth;
      const max = this.maxScroll();

      // Overflow under 12px is treated as none. Sub-pixel layout, the strip's negative margin
      // and the trailing gap routinely leave a few px of travel with no topic actually hidden,
      // and paginating that produces a second dot that moves almost nowhere. 12px is well
      // under the narrowest chip, so no genuinely clipped topic is ever missed.
      if (!clientWidth || max <= 12) return 0;

      // Counted from the travel distance, NOT Math.ceil(scrollWidth / clientWidth). That older
      // formula could yield a final dot whose target (index * clientWidth) sat beyond max —
      // unreachable, so scrolling clamped short of it and the dot never became active. Here
      // the last dot always lands exactly on max.
      return Math.ceil(max / clientWidth) + 1;
    }

    buildDots() {
      const pages = this.pageCount();

      if (pages < 2) {
        this.dots.classList.remove('is-visible');
        this.dots.replaceChildren();
        return;
      }

      if (this.dots.children.length !== pages) {
        const frag = document.createDocumentFragment();
        for (let i = 0; i < pages; i += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'faq-rail__dot';
          dot.setAttribute('aria-label', `Go to topics page ${i + 1} of ${pages}`);
          dot.addEventListener('click', () => {
            // Spread evenly across the reachable range so the first dot is 0, the last is
            // exactly max, and every dot in between maps to a position that can be held.
            const max = this.maxScroll();
            const target = pages > 1 ? (i / (pages - 1)) * max : 0;
            this.railList.scrollTo({ left: target, behavior: 'smooth' });
          });

          const inner = document.createElement('span');
          inner.className = 'faq-rail__dot-inner';
          dot.appendChild(inner);
          frag.appendChild(dot);
        }
        this.dots.replaceChildren(frag);
      }

      this.dots.classList.add('is-visible');
      this.syncDots();
    }

    syncDots() {
      const dots = Array.from(this.dots.children);
      if (!dots.length) return;

      // Mapped proportionally against the travel distance, matching how the click targets are
      // laid out above. Dividing by clientWidth instead would mean the final dot only lit up
      // if the content happened to be an exact multiple of the viewport width — which is why
      // the last dot previously stayed inactive no matter how far the strip was swiped.
      const max = this.maxScroll();
      const ratio = max > 0 ? this.railList.scrollLeft / max : 0;
      const index = Math.round(ratio * (dots.length - 1));
      const active = Math.max(0, Math.min(index, dots.length - 1));

      dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', String(i === active));
      });
    }

    selectCategory(id) {
      this.tabs.forEach((tab) => {
        tab.setAttribute('aria-selected', String(tab.dataset.faqTab === id));
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.faqPanel !== id;
      });
    }

    filter() {
      const term = this.searchInput.value.trim().toLowerCase();

      // With a search term every category is shown at once, since a match may sit in any of
      // them and silently hiding matches behind an unselected tab would look like no result.
      this.panels.forEach((panel) => {
        const items = Array.from(panel.querySelectorAll('[data-faq-item]'));
        let visible = 0;

        items.forEach((item) => {
          if (!term) {
            item.hidden = false;
            visible += 1;
            return;
          }

          const question = (item.querySelector('[data-faq-question]')?.textContent || '').toLowerCase();
          const answer = (item.querySelector('[data-faq-answer]')?.textContent || '').toLowerCase();
          const match = question.includes(term) || answer.includes(term);

          item.hidden = !match;
          if (match) visible += 1;
        });

        const noResults = panel.querySelector('[data-faq-no-results]');
        if (noResults) noResults.hidden = !term || visible > 0 || items.length === 0;

        const count = panel.querySelector('[data-faq-panel-count]');
        if (count) count.hidden = Boolean(term);

        if (term) {
          panel.hidden = visible === 0;
        }
      });

      if (!term) {
        const selected = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
        const activeId = selected ? selected.dataset.faqTab : null;
        this.panels.forEach((panel) => {
          panel.hidden = activeId ? panel.dataset.faqPanel !== activeId : false;
        });
      }
    }
  }

  function initNexFaq(scope) {
    (scope || document).querySelectorAll('[data-faq-root]').forEach((root) => {
      if (root.dataset.faqInit === 'true') return;
      root.dataset.faqInit = 'true';
      new NexFaq(root);
    });
  }

  initNexFaq();

  // The theme editor re-renders a section through its own AJAX pipeline on every edit, which
  // swaps in fresh markup that never had these listeners attached. Same pattern already used
  // for the header's mega menu hover.
  document.addEventListener('shopify:section:load', (event) => {
    initNexFaq(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-nx-dots]').forEach(function (dotsEl) {
    var collection = dotsEl.closest('.collection');
    var rail = collection && collection.querySelector('.product-grid.slider--tablet');
    var dots = dotsEl.querySelectorAll('.collection__mobile-dot');
    if (!rail || !dots.length) return;

    rail.addEventListener(
      'scroll',
      function () {
        var slide = rail.querySelector('.grid__item');
        if (!slide) return;
        var step = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 14);
        /* Clamped: sub-pixel gap rounding at the extremes can put the computed
           index past the last dot, which would leave none of them active. */
        var index = Math.round(rail.scrollLeft / step);
        if (index < 0) index = 0;
        if (index > dots.length - 1) index = dots.length - 1;
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      },
      { passive: true }
    );
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Shared by both hover handlers below — read from data attributes rendered onto
  // .header-wrapper for the "Open Mega menu on hover" / "Open Drawer menu on hover" /
  // "Hover close delay" settings (Liquid template code doesn't run inside this script
  // block, so their values can't be interpolated directly in here). Mega menu and
  // drawer each get their own toggle since one runs on desktop and the other on
  // mobile/tablet (or desktop too, if Menu type on desktop is set to Drawer).
  function isMegaMenuHoverEnabled() {
    return document.querySelector('.header-wrapper')?.dataset.megaHoverEnabled === 'true';
  }

  function isDrawerHoverEnabled() {
    return document.querySelector('.header-wrapper')?.dataset.drawerHoverEnabled === 'true';
  }

  function getHoverCloseDelay() {
    const value = document.querySelector('.header-wrapper')?.dataset.hoverCloseDelay;
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? 150 : parsed;
  }

  // Dawn's header-menu (details-disclosure.js) only opens the mega menu on click/focus.
  // This adds hover-to-open for pointer devices, scoped to elements marked
  // .mega-menu-hover (rendered only by header-mega-menu.liquid, not the dropdown menu),
  // without modifying the shared details-disclosure.js asset.
  //
  // The Shopify theme editor re-renders sections via AJAX (its own Section Rendering
  // API pipeline) whenever a setting/block changes, swapping in fresh HTML that never
  // had these listeners attached — a script that only runs once at parse time misses
  // that HTML entirely. initMegaMenuHover() is re-run on the theme editor's
  // `shopify:section:load` event (fired after each such re-render) so hover keeps
  // working there, not just on a normal storefront page load.
  function initMegaMenuHover(root) {
    if (!isMegaMenuHoverEnabled() || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    (root || document).querySelectorAll('header-menu.mega-menu-hover').forEach((menu) => {
      if (menu.dataset.hoverInit) return;
      menu.dataset.hoverInit = 'true';
      const details = menu.querySelector('details');
      const summary = details && details.querySelector('summary');
      if (!details || !summary) return;
      let closeTimer;
      let openedByHover = false;
      menu.addEventListener('mouseenter', () => {
        window.clearTimeout(closeTimer);
        if (!details.open) openedByHover = true;
        details.open = true;
      });
      menu.addEventListener('mouseleave', () => {
        openedByHover = false;
        closeTimer = window.setTimeout(() => {
          details.open = false;
        }, getHoverCloseDelay());
      });
      // Without this, a click landing on an already hover-opened summary would hit
      // native <details> toggle-on-click and immediately close what hover just opened.
      // Only suppress that one click — keyboard/touch users, who never trigger
      // mouseenter, still get normal native click/Enter toggle behavior.
      summary.addEventListener('click', (event) => {
        if (openedByHover) {
          event.preventDefault();
          openedByHover = false;
        }
      });
    });
  }

  initMegaMenuHover();

  // Lets a top-level nav item that owns a dropdown still act as a link. The <summary>'s
  // native activation fires for clicks anywhere inside it, so the anchor has to stop the
  // event before it gets there; the anchor's own default navigation is left alone. Same
  // idempotent, re-runnable shape as initMegaMenuHover so it survives the theme editor
  // re-rendering the header.
  function initMegaMenuItemLinks(root) {
    (root || document).querySelectorAll('[data-mega-menu-item-link]').forEach((anchor) => {
      if (anchor.dataset.linkInit) return;
      anchor.dataset.linkInit = 'true';
      anchor.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    });
  }

  initMegaMenuItemLinks();

  // Same hover-to-expand treatment for the mobile drawer's accordion items — hovering
  // the nav item name expands it instead of requiring a click/arrow icon (which was
  // removed from the markup). Listeners go on the <details> itself, not just the
  // <summary>: since the submenu panel is a DOM descendant of its <details> even
  // though it's positioned absolutely to slide over the parent view, moving the
  // pointer into it doesn't fire the parent's mouseleave — same containment logic as
  // the mega menu's header-menu wrapper above.
  //
  // Unlike the mega menu (a plain <details>/<summary> pair driven by the generic
  // DetailsDisclosure/HeaderMenu classes, which react to the native `toggle` event),
  // the drawer's submenus are managed by MenuDrawer/HeaderDrawer in global.js, which
  // binds its open/close logic directly to `summary` and `.menu-drawer__close-button`
  // *click* events — it adds classes (menu-opening, submenu-open), sets aria-expanded,
  // traps focus, etc. Setting `details.open` directly bypasses all of that and the
  // submenu never visually appears. So hover here simulates real clicks on the same
  // elements a user would tap, letting Dawn's own click handlers do the work
  // correctly instead of duplicating that logic.
  function initDrawerHover(root) {
    if (!isDrawerHoverEnabled() || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    (root || document).querySelectorAll('.menu-drawer__navigation details').forEach((details) => {
      if (details.dataset.hoverInit) return;
      details.dataset.hoverInit = 'true';
      const summary = details.querySelector(':scope > summary');
      if (!summary) return;
      const closeButton = details.querySelector(':scope > div.menu-drawer__submenu .menu-drawer__close-button');
      let closeTimer;
      details.addEventListener('mouseenter', () => {
        window.clearTimeout(closeTimer);
        if (!details.hasAttribute('open')) summary.click();
      });
      details.addEventListener('mouseleave', () => {
        closeTimer = window.setTimeout(() => {
          if (details.hasAttribute('open') && closeButton) closeButton.click();
        }, getHoverCloseDelay());
      });
    });
  }

  initDrawerHover();

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      initMegaMenuHover(event.target);
      initMegaMenuItemLinks(event.target);
      initDrawerHover(event.target);
    });
  }

  // inspiration/homepage.dc.html shows a "⌘K" hint next to the inline search bar. This
  // makes it a real shortcut (not decorative): Cmd+K on Mac, Ctrl+K elsewhere, focuses
  // the inline search input. The hint label itself is swapped to match the platform.
  function isMacPlatform() {
    return /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent);
  }

  document.querySelectorAll('[data-search-shortcut-hint]').forEach((hint) => {
    hint.textContent = isMacPlatform() ? '⌘K' : 'Ctrl K';
  });

  document.addEventListener('keydown', (event) => {
    const isShortcut = (event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k';
    if (!isShortcut) return;
    const input = document.querySelector('.header__search-inline .search__input');
    if (!input) return;
    event.preventDefault();
    input.focus();
  });

  // Drawer menu's compact country/currency button (inspiration/Drawer Menu/Mobile Drawer
  // Menu.dc.html shows a flag emoji, e.g. 🇬🇧). Rather than hardcoding one flag per
  // country — which would need updating by hand every time Shopify Markets adds or
  // removes a region — this derives the flag from the real current country's ISO code
  // (data-country-flag, rendered by snippets/country-localization.liquid) using the
  // standard regional-indicator-symbol trick: each letter maps to the Unicode codepoint
  // U+1F1E6 + (letter offset from 'A'), and two of those combined render as that
  // country's flag in any emoji-capable font. Works for any real ISO code automatically.
  function isoCodeToFlagEmoji(isoCode) {
    if (!isoCode || isoCode.length !== 2) return '';
    const codePoints = isoCode
      .toUpperCase()
      .split('')
      .map((letter) => 0x1f1e6 + (letter.charCodeAt(0) - 65));
    return String.fromCodePoint(...codePoints);
  }

  document.querySelectorAll('[data-country-flag]').forEach((flagEl) => {
    flagEl.textContent = isoCodeToFlagEmoji(flagEl.dataset.countryFlag);
  });

  // Desktop compact sticky header ("Enable compact sticky header" setting): past the
  // configured scroll distance, .header--compact-active is added, which the CSS above
  // uses to shrink the header, scale the logo, and swap .header__inline-menu for a
  // hamburger toggle. This is intentionally independent of Dawn's own sticky-header
  // custom element/its "Sticky header" (on-scroll-up/always/reduce-logo-size) setting —
  // both can be used together or separately without conflicting, since they toggle
  // different class names.
  function initCompactStickyHeader() {
    const wrapper = document.querySelector('.header-wrapper[data-compact-sticky-header="true"]');
    if (!wrapper || wrapper.dataset.compactInit) return;
    wrapper.dataset.compactInit = 'true';

    const scrollDistance = parseInt(wrapper.dataset.compactScrollDistance, 10) || 100;
    const toggle = wrapper.querySelector('.header__compact-nav-toggle');
    const nav = toggle ? document.getElementById(toggle.getAttribute('aria-controls')) : null;

    let isActive = false;
    let ticking = false;

    function applyScrollState() {
      const shouldBeActive = window.scrollY > scrollDistance;
      if (shouldBeActive === isActive) {
        ticking = false;
        return;
      }
      isActive = shouldBeActive;
      wrapper.classList.toggle('header--compact-active', isActive);
      if (!isActive) closeNav();
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(applyScrollState);
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    if (!toggle || !nav) return;

    function openNav() {
      wrapper.classList.add('header--compact-nav-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', onDocumentClick, true);
      document.addEventListener('keydown', onKeydown, true);
    }

    function closeNav({ returnFocus = false } = {}) {
      wrapper.classList.remove('header--compact-nav-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onDocumentClick, true);
      document.removeEventListener('keydown', onKeydown, true);
      if (returnFocus) toggle.focus();
    }

    function onDocumentClick(event) {
      if (nav.contains(event.target) || toggle.contains(event.target)) return;
      closeNav();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') closeNav({ returnFocus: true });
    }

    toggle.addEventListener('click', () => {
      if (wrapper.classList.contains('header--compact-nav-open')) {
        closeNav();
      } else {
        openNav();
      }
    });
  }

  initCompactStickyHeader();

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initCompactStickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class DiscountCodeForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.cart-discount__input');
      this.button = this.querySelector('.cart-discount__apply');
      this.button.addEventListener('click', () => this.apply());
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.apply();
        }
      });
    }

    apply() {
      const code = this.input.value.trim();
      if (!code) return;
      const root = this.dataset.rootUrl || '/';
      const cartUrl = this.dataset.cartUrl || `${root}cart`;
      window.location.href = `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(cartUrl)}`;
    }
  }

  customElements.define('discount-code-form', DiscountCodeForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function initProductGalleryDots(root) {
    root.querySelectorAll('[data-gallery-dots]').forEach(function (dotsEl) {
      if (dotsEl.dataset.dotsInit) return;
      var track = document.getElementById(dotsEl.dataset.target);
      if (!track) return;
      dotsEl.dataset.dotsInit = 'true';

      var dots = Array.prototype.slice.call(dotsEl.querySelectorAll('[data-index]'));

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.dataset.index, 10);
          track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
        });
      });

      track.addEventListener(
        'scroll',
        function () {
          if (!track.clientWidth) return;
          var index = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === index);
          });
        },
        { passive: true }
      );
    });
  }

  function initHoverMagnify(root) {
    root.querySelectorAll('[data-zoom-both] .product__modal-opener--image').forEach(function (opener) {
      if (opener.dataset.magnifyInit) return;
      const img = opener.querySelector('img');
      if (!img) return;
      opener.dataset.magnifyInit = 'true';

      let overlay = null;

      function createOverlay() {
        overlay = document.createElement('div');
        overlay.className = 'nex-hover-magnify';
        overlay.style.backgroundImage = 'url(' + (img.currentSrc || img.src) + ')';
        img.parentElement.appendChild(overlay);
      }

      function updatePosition(event) {
        if (!overlay) return;
        const rect = img.getBoundingClientRect();
        const xPercent = ((event.clientX - rect.left) / rect.width) * 100;
        const yPercent = ((event.clientY - rect.top) / rect.height) * 100;
        overlay.style.backgroundPosition = xPercent + '% ' + yPercent + '%';
        overlay.style.backgroundSize = rect.width * 2 + 'px ' + rect.height * 2 + 'px';
      }

      opener.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: hover)').matches) createOverlay();
      });
      opener.addEventListener('mousemove', function (event) {
        updatePosition(event);
      });
      opener.addEventListener('mouseleave', function () {
        if (overlay) {
          overlay.remove();
          overlay = null;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductGalleryDots(document);
    initHoverMagnify(document);
  });
  if (document.readyState !== 'loading') {
    initProductGalleryDots(document);
    initHoverMagnify(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initProductGalleryDots(event.target);
    initHoverMagnify(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const tab = event.target.closest('.product-tabs__tab');
    if (!tab) return;
    const root = tab.closest('product-tabs');
    if (!root) return;
    root.querySelectorAll('.product-tabs__tab').forEach(function (t) {
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
    });
    const target = tab.dataset.tabTarget;
    root.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.tabPanel !== target;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
